import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";

function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError("");
    const base = process.env.REACT_APP_API_URL || window.location.origin;
    const API_URL = `${base}/v2/subscribers`;

    try {
      const resp = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      if (resp.ok) {
        setSuccess(true);
        setEmail("");
        setTimeout(() => setSuccess(false), 4000);
      } else {
        const data = await resp.json().catch(() => ({}));
        setError(data.error || "Алдаа гарлаа. Дахин оролдоно уу.");
        setTimeout(() => setError(""), 4000);
      }
    } catch (err) {
      setError("Сервертэй холбогдож чадсангүй.");
      setTimeout(() => setError(""), 4000);
    }
    setLoading(false);
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  useEffect(() => {
    const toggleVisibility = () => setIsVisible(window.pageYOffset > 500);
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const columns = [
    {
      title: "Intelligence",
      links: ["Social Sentiment Ingestion", "OSINT Research Node", "Neural Threat Detection", "APT Response Protocol", "Dark Web Monitoring"],
    },
    {
      title: "Tactical Systems",
      links: ["Vision-AI Perimeter", "Biometric Access Logic", "Active Denial Hardware", "Facility Hardening", "Spatial Mapping"],
    },
    {
      title: "Strategic Protocol",
      links: ["Cyber Ops Academy", "Custom ERP Systems", "AI Neural Integration", "Strategic Consulting", "Contact Node"],
    },
  ];

  return (
    <footer style={{
      background: "linear-gradient(180deg, #020410 0%, #0D0F35 100%)",
      borderTop: "1px solid rgba(255,255,255,0.06)",
      padding: "100px 30px 40px",
      position: "relative",
      overflow: "hidden",
    }}>
      <style>{`
        .footer-link:hover { color: #00D4FF !important; transform: translateX(5px); }
        .social-btn:hover { background: rgba(92,39,254,0.3) !important; border-color: #5C27FE !important; transform: translateY(-3px); }
        .subscribe-btn:hover { box-shadow: 0 0 25px rgba(92,39,254,0.5) !important; transform: scale(1.02); }

        .nl-box   { padding: 50px 60px; margin-bottom: 100px; }
        .nl-text  { flex: 1.2; min-width: 300px; }
        .nl-form  { display: flex; gap: 15px; flex: 1; min-width: 320px; }

        @media (max-width: 768px) {
          .nl-box  { padding: 30px 22px !important; margin-bottom: 60px !important; border-radius: 20px !important; }
          .nl-text { min-width: 100% !important; }
          .nl-form { flex-direction: column !important; min-width: 100% !important; gap: 10px !important; }
          .nl-form input  { width: 100% !important; }
          .nl-form button { width: 100% !important; padding: 15px !important; }
        }
      `}</style>
      
      <div style={{ maxWidth: "1280px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <div className="nl-box" style={{
          background: "linear-gradient(135deg, rgba(92,39,254,0.2), rgba(0,212,255,0.1))",
          border: "1px solid rgba(255,255,255,0.08)", borderRadius: "32px",
          display: "flex", flexWrap: "wrap", gap: "30px", alignItems: "center",
          backdropFilter: "blur(20px)"
        }}>
          <div className="nl-text">
            <h3 style={{ fontSize: "26px", fontFamily: "'Conthrax', sans-serif", color: "#fff", marginBottom: "10px" }}>
              Join the Intelligence Grid
            </h3>
            <p style={{ fontSize: "15px", fontFamily: "'Readex Pro', sans-serif",
              color: success ? "#4ade80" : error ? "#f87171" : "rgba(255,255,255,0.5)" }}>
              {success ? "Welcome to the network." : error ? error : "Receive our latest briefings on digital movement and brand security."}
            </p>
          </div>
          <form onSubmit={handleSubscribe} className="nl-form" style={{ flex: "1" }}>
            <input
              type="email"
              value={email}
              required
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter Access Email"
              style={{
                flex: 1, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.15)",
                borderRadius: "15px", padding: "18px 24px", color: "#fff", fontSize: "14px",
                fontFamily: "monospace", outline: "none", transition: "all 0.3s"
              }}
            />
            <button type="submit" disabled={loading} className="subscribe-btn" style={{
              background: "linear-gradient(135deg, #5C27FE, #7C3AED)",
              border: "none", borderRadius: "15px", padding: "18px 35px",
              color: "#fff", fontSize: "12px", fontFamily: "'Conthrax', sans-serif",
              cursor: "pointer", transition: "all 0.3s", whiteSpace: "nowrap",
              boxShadow: "0 10px 30px rgba(92,39,254,0.3)"
            }}>{loading ? "SYCNING..." : "CONNECT"}</button>
          </form>
        </div>

        <div className="row g-5 mb-5">
          <div className="col-lg-5">
            <img src={logo} alt="INTELLX SECURITY" style={{ height: "45px", marginBottom: "30px" }} />
            <p style={{
              fontSize: "15px", color: "rgba(255,255,255,0.4)", lineHeight: 1.8,
              fontFamily: "'Readex Pro', sans-serif", marginBottom: "35px", maxWidth: "450px"
            }}>
                A comprehensive intelligence ecosystem delivering elite consulting across six strategic nodes: 
                Media OSINT, Cyber Defense, AI Systems, IP Surveillance, Physical Hardening, and Security Training. 
                Orchestrating global resilience through multi-spectrum data dominance.
            </p>
          </div>

          <div className="col-lg-7">
            <div className="row">
               {columns.map((col, i) => (
                <div key={i} className="col-md-4">
                  <h6 style={{
                    fontSize: "13px", fontFamily: "'Conthrax', sans-serif", color: "#fff",
                    marginBottom: "30px", letterSpacing: "2px", fontWeight: "900"
                  }}>{col.title.toUpperCase()}</h6>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {col.links.map((l, j) => (
                      <li key={j} style={{ marginBottom: "16px" }}>
                        <Link to="#" className="footer-link" style={{
                          fontSize: "14px", color: "rgba(255,255,255,0.4)",
                          fontFamily: "'Readex Pro', sans-serif", transition: "all 0.3s",
                          display: "inline-block", textDecoration: "none"
                        }}>{l}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "40px",
          display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "space-between", alignItems: "center",
        }}>
          <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.25)", fontFamily: "'Readex Pro', sans-serif" }}>
            © {new Date().getFullYear()} ADVANCED INTELLX GLOBAL INTELLIGENCE. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>

      {isVisible && (
        <button onClick={scrollToTop} style={{
          position: "fixed", bottom: "40px", right: "40px",
          width: "55px", height: "55px", borderRadius: "18px",
          background: "linear-gradient(135deg, #5C27FE, #7C3AED)",
          border: "none", color: "#fff", fontSize: "22px",
          cursor: "pointer", boxShadow: "0 12px 30px rgba(92,39,254,0.4)",
          transition: "all 0.3s ease", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center"
        }}>↑</button>
      )}
    </footer>
  );
}

export default Footer;
